import { render, staticRenderFns } from "./CompanyEdit.vue?vue&type=template&id=d5553f8a&scoped=true"
import script from "./CompanyEdit.vue?vue&type=script&lang=js"
export * from "./CompanyEdit.vue?vue&type=script&lang=js"
import style0 from "./CompanyEdit.vue?vue&type=style&index=0&id=d5553f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5553f8a",
  null
  
)

export default component.exports